import { create } from "zustand";

interface IHistoryPathStore {
  data: string;
  setData: (data: string) => void;
}
const useHistoryPathStore = create<IHistoryPathStore>((set) => {
  return {
    data: "",
    setData: (data: string) => set(() => ({ data })),
  };
});

export default useHistoryPathStore;
